import * as React from 'react';
import {
  makeCancelable,
  CancelablePromise
} from 'app/infrastructure/js/cancelable-promise';
import { error } from 'app/infrastructure/log';

import type { JSX } from "react";

export interface RemoteBlobProps {
  loadBlob: () => Promise<Blob>;
  children(props: RemoteBlobInjectedProps): JSX.Element;
  onLoad?: () => void;
  onError?: () => void;
}

export interface RemoteBlobState {
  objectUrl?: string;
  error: boolean;
}

export interface RemoteBlobInjectedProps {
  objectUrl?: string;
  error: boolean;
}

export class RemoteBlob extends React.Component<
  RemoteBlobProps,
  RemoteBlobState
> {
  private loadPromise: CancelablePromise<Blob>;

  constructor(props: RemoteBlobProps) {
    super(props);

    this.state = {
      objectUrl: undefined,
      error: false
    };
  }

  public async componentDidMount() {
    if (!this.props.loadBlob) {
      return;
    }
    
    try {
      this.loadPromise = makeCancelable(this.props.loadBlob());
      const blob = await this.loadPromise.promise;
      blob && this.setState({ objectUrl: window.URL.createObjectURL(blob) });
      this.loadPromise = undefined;
      this.props.onLoad && this.props.onLoad();
      if (!blob) {
        this.setState({ error: true });
        this.props.onError && this.props.onError();
      }
    } catch (e) {
      if (e && e.isCanceled) {
        return;
      }
      error(e);
      this.setState({ error: true });
      this.props.onError && this.props.onError();
    }
  }

  public componentWillUnmount() {
    if (this.state.objectUrl) {
      window.URL.revokeObjectURL(this.state.objectUrl);
    }
    if (this.loadPromise) {
      this.loadPromise.cancel();
      this.loadPromise = undefined;
    }
  }

  public render() {
    return (
      this.props.children &&
      this.props.children({
        objectUrl: this.state.objectUrl,
        error: this.state.error
      })
    );
  }
}
